import { render, staticRenderFns } from "./CommissionSettingsView.vue?vue&type=template&id=28b3f851&scoped=true&"
import script from "./CommissionSettingsView.vue?vue&type=script&lang=js&"
export * from "./CommissionSettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b3f851",
  null
  
)

export default component.exports